<!--Modals-->
<app-deprecated-confirmation-dialog
    #confirmation
    header="{{ 'time-off-v3.selectEffectiveDateForYourChanges' | translate }}"
    label="{{ 'time-off-v3.save' | translate }}"
    [negative]="true"
    [useNgContent]="true"
>
    <p class="margin-bottom-1">
        {{ 'time-off-v3.changesWillImpactEveryoneAssignedToThisPolicy' | translate }}<br />{{
            'time-off-v3.ifYoureTryingToFuturedateAChangeTryCloningandAssigningThePolicyInstead' | translate
        }}
    </p>
    <mat-form-field class="margin-bottom-1">
        <mat-label appRemoveAriaOwns>{{ 'time-off-v3.EffectiveDate' | translate }}</mat-label>
        <mat-select required name="effectiveDate" [(ngModel)]="timeOffPolicy.effectiveDate">
            <mat-option [value]="todayValue">{{ 'time-off-v3.today' | translate }}</mat-option>
            <mat-option [value]="dateHiredValue">{{ 'time-off-v3.dateHired' | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <ui-banner variant="warning">
        <p>{{ warningMessage | appTranslate }}</p>
    </ui-banner>
</app-deprecated-confirmation-dialog>
<div class="ui basic segment max-width" [class.loading]="isLoading">
    <app-header [back]="true" title="{{ 'time-off-v3.editTimeOffPolicy' | translate }}"></app-header>
    <div *ngIf="hasCompletedInitialLoad">
        <div class="ui segment">
            <app-time-off-policy-form
                #policyForm
                [timeOffTypes]="timeOffTypes"
                [timeOffPolicy]="timeOffPolicy"
                [timeOffApprovalFlows]="timeOffApprovalFlows"
                [requestRule]="requestRules"
                actionType="update"
            ></app-time-off-policy-form>
        </div>

        <div class="ui segment" *ngIf="showAdvanceSetting()">
            <app-segment-header [title]="'time-off-v3.advancedSettings' | translate"></app-segment-header>
            <div class="content">
                <app-advanced-policy-form
                    #advancePolicyForm
                    [timeOffPolicy]="timeOffPolicy"
                    [requestRules]="requestRules"
                ></app-advanced-policy-form>
            </div>
        </div>
        <div class="buttons">
            <ui-button type="outline" (click)="onCancel()">{{ 'time-off-v3.cancel' | translate }}</ui-button>
            <ui-button type="primary" (click)="onSave()">{{ 'time-off-v3.save' | translate }}</ui-button>
        </div>
    </div>
</div>
